/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:05:47
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-23 11:44:40
 */
import Konva from 'konva'
import { Graph } from './graph.js'
import { GraphElement } from './graph-element.js'
import { RemoveObjectRecord } from './history/record.js'
import { BusElement } from './element/element-bus.js'

export class Storage {

  /**
   *
   * @param {import('./topology.js').Topology} topology
   */
  constructor(topology) {
    this.topology = topology
    this.graph = new Graph()
    this.selectedElement = null
    this.selectedList = []
    this.displayElement = []



    // 网格和标尺相关
    this.gridSize = 20
    this.outerGridColor = 'rgba(0,255,0,0.5)'
    this.gridColor = 'rgba(255,255,255,0.2)'
    this.ruleColor = 'rgba(255,255,255,1)'

    this.init()
  }

  init() {
    this.initStage()
    this.initLayers()
    this.initReferenceLine()
    this.initBoundingBox()
    // this.initRules()
    // this.initGrid()
  }

  /**
   * 初始化舞台
   */
  initStage() {
    const container = this.topology.dom.graphElem
    const { width, height } = container.getBoundingClientRect()

    this.stage = new Konva.Stage({
      container: container,
      width: width,
      height: height,
      draggable: false,
    })

    window.addEventListener('resize', () => {
      this.resize()
    })

    setTimeout(() => {
      this.resize()
    }, 1000)
  }


  /**
   * 初始化网格
   */
  initGrid() {
    const { gridSize, gridColor, outerGridColor } = this
    //
    const width = this.stage.width()
    const height = this.stage.height()
    const scaleX = this.stage.scaleX()
    const scaleY = this.stage.scaleY()
    const stageX = this.stage.x()
    const stageY = this.stage.y()

    // 列数
    const lenX = Math.ceil(width / scaleX / gridSize)
    // 行数
    const lenY = Math.ceil(height / scaleY / gridSize)

    const startX = -Math.ceil(stageX / scaleX / gridSize)
    const startY = -Math.ceil(stageY / scaleY / gridSize)

    const group = new Konva.Group()


    // 外侧边框
    group.add(
      new Konva.Rect({
        name: this.constructor.name,
        x: 0,
        y: 0,
        width: width,
        height: height,
        stroke: outerGridColor,
        strokeWidth: 2 / scaleY,
        listening: false,
        dash: [4, 4]
      })
    )


    // 竖线
    for (let x = startX; x < lenX + startX + 1; x++) {
      group.add(
        new Konva.Line({
          name: this.constructor.name,
          points: [
            gridSize * x,
            -stageY / scaleY,
            gridSize * x,
            (height - stageY) / scaleY
          ],
          stroke: gridColor,
          strokeWidth: 1 / scaleY,
          listening: false
        })
      )
    }


    // 横线
    for (let y = startY; y < lenY + startY + 1; y++) {
      group.add(
        new Konva.Line({
          name: this.constructor.name,
          points: [
            -stageX / scaleX,
            gridSize * y,
            (width - stageX) / scaleX,
            gridSize * y,
          ],
          stroke: gridColor,
          strokeWidth: 1 / scaleX,
          listening: false
        })
      )
    }

    this.layerGridAndRules.add(group)

  }


  /**
   * 初始化标尺
   */
  initRules() {
    const { gridSize, gridColor, outerGridColor, ruleColor } = this

    //
    const width = this.stage.width()
    const height = this.stage.height()
    const scaleX = this.stage.scaleX()
    const scaleY = this.stage.scaleY()
    const stageX = this.stage.x()
    const stageY = this.stage.y()

    // 列数
    const lenX = Math.ceil(width / scaleX / gridSize)
    // 行数
    const lenY = Math.ceil(height / scaleY / gridSize)

    const startX = -Math.ceil(stageX / scaleX / gridSize)
    const startY = -Math.ceil(stageY / scaleY / gridSize)

    const group = new Konva.Group()
    // 标尺
    group.add(
      new Konva.Line({
        name: 'rule-x',
        points: [0, 0, 1600, 0],
        stroke: ruleColor,
        strokeWidth: 1,
        listening: false
      })
    )

    // x轴上的标尺
    for (let x = startX; x < lenX + startX + 1; x++) {
      let name = 'rule-x-' + x
      let y = x % 5 === 0 ? 10 : 5
      // console.log('startX', [x, name]);

      group.add(
        new Konva.Line({
          name: name,
          points: [
            gridSize * x,
            0,
            gridSize * x,
            y,
          ],
          stroke: ruleColor,
          strokeWidth: 1 / scaleY,
          listening: false
        })
      )
    }

    group.add(
      new Konva.Line({
        name: 'rule-y',
        points: [0, 0, 0, 1600],
        stroke: ruleColor,
        strokeWidth: 1,
        listening: false
      })
    )

    // y轴上的标尺
    for (let y = startY; y < lenY + startY + 1; y++) {
      let name = 'rule-y-' + y
      let x = y % 5 === 0 ? 10 : 5
      // console.log('startY', [y, name]);

      group.add(
        new Konva.Line({
          name: name,
          points: [
            0,
            gridSize * y,
            x,
            gridSize * y,
          ],
          stroke: ruleColor,
          strokeWidth: 1 / scaleX,
          listening: false
        })
      )
    }

    this.layerGridAndRules.add(group)

  }

  resize() {
    const container = this.topology.dom.graphElem
    const { width, height } = container.getBoundingClientRect()
    this.stage.width(width)
    this.stage.height(height)
  }

  setEditable(draggable) {
    this.displayElement.forEach(ge => {
      ge.g.setAttr('draggable', draggable)
    })
  }

  /**
   * 初始化参考线
   */
  initReferenceLine() {
    const lineColor = '#FF48C1'
    // x轴上的参考线
    let xRefLine = new Konva.Rect({
      x: 0,
      y: 0,
      width: 1,
      height: 1600,
      fill: lineColor,
      stroke: '#fff',
      strokeWidth: 0,
      // draggable: true,
      name: 'x-refline',
      visible: false,
    })

    // y轴上的参考线
    let yRefLine = new Konva.Rect({
      x: 0,
      y: 0,
      width: 1600,
      height: 1,
      fill: lineColor,
      stroke: '#fff',
      strokeWidth: 0,
      // draggable: true,
      name: 'y-refline',
      visible: false,
    })

    this.layerRefLine.add(xRefLine)
    this.layerRefLine.add(yRefLine)

    this.xRefLine = xRefLine
    this.yRefLine = yRefLine
  }

  // 初始化边界框
  initBoundingBox() {

    const pointSize = 6
    const boxWidth = 1660
    const boxHeight = 760



    if (this.topology.editor) {

      // 四个角
      const leftTop = new Konva.Rect({
        x: -pointSize / 2,
        y: -pointSize / 2,
        width: pointSize,
        height: pointSize,
        fill: '#FF48C1',
        stroke: '#fff',
        strokeWidth: 0,
        name: 'leftTop',
        visible: true,
        strokeHitEnabled: false,
        hitFunc: () => false,
      })

      const leftBottom = new Konva.Rect({
        x: -pointSize / 2,
        y: boxHeight - pointSize / 2,
        width: pointSize,
        height: pointSize,
        fill: '#FF48C1',
        stroke: '#fff',
        strokeWidth: 0,
        name: 'leftBottom',
        visible: true,
        strokeHitEnabled: false,
        hitFunc: () => false,
      })

      const rightTop = new Konva.Rect({
        x: boxWidth - pointSize / 2,
        y: - pointSize / 2,
        width: pointSize,
        height: pointSize,
        fill: '#FF48C1',
        stroke: '#fff',
        strokeWidth: 0,
        name: 'rightTop',
        visible: true,
        strokeHitEnabled: false,
        hitFunc: () => false,
      })


      const rightBottom = new Konva.Rect({
        x: boxWidth - pointSize / 2,
        y: boxHeight - pointSize / 2,
        width: pointSize,
        height: pointSize,
        fill: '#FF48C1',
        stroke: '#fff',
        strokeWidth: 0,
        name: 'rightBottom',
        visible: true,
        strokeHitEnabled: false,
        hitFunc: () => false,
      })

      const baseRect = new Konva.Rect({
        x: 0,
        y: 0,
        width: boxWidth,
        height: boxHeight,
        stroke: 'rgba(255,255,255,0.2)',
        name: 'baseRect',
        strokeWidth: 1,
        dash: [4, 4],
        visible: true,
        strokeHitEnabled: false,
        hitFunc: () => false,
      })

      this.layer.add(baseRect, leftTop, leftBottom, rightTop, rightBottom)
    }

  }



  /**
   * 初始化图层
   */
  initLayers() {
    // 标尺与网格
    this.layerGridAndRules = new Konva.Layer()
    // 常规元素图层
    this.layer = new Konva.Layer()
    // 参考线图层
    this.layerRefLine = new Konva.Layer()
    // 元素之间的连线图层
    this.layerLines = new Konva.Layer()

    this.stage.add(this.layerGridAndRules)
    this.stage.add(this.layerLines)
    this.stage.add(this.layer)
    this.stage.add(this.layerRefLine)
  }

  /**
   * 给layer中添加元素
   * @param {*} elem
   */
  addElement(elem) {
    if (elem instanceof GraphElement) {
      if (elem.keyShape) {
        elem.addToLayer(this.layer)
        this.layer.batchDraw()
      } else {
        elem.onLoad(() => {
          // console.log('elem onload')
          elem.addToLayer(this.layer)
          this.layer.batchDraw()
        })
      }

      this.graph.addVertex(elem)
      this.displayElement.push(elem)
    }
  }

  /**
   * 选中元素
   * @param {*} elem
   */
  select(elem) {
    if (this.selectedElement === elem) {
      return
    }
    this.selectedElement = elem

    this.topology.dispatchEvent({
      type: 'topo:select',
      data: elem
    })
  }

  /**
   * 取消当前选中元素
   */
  deselect() {
    this.select(null)
  }

  /**
   * 删除当前选中的元素
   */
  removeSelectedElement() {
    this.topology.history.push(new RemoveObjectRecord(this.topology, this.selectedElement))
    this.removeElement(this.selectedElement)

    this.selectedList.forEach(elem => {
      this.topology.history.push(new RemoveObjectRecord(this.topology, elem))
      this.removeElement(elem)
    })

    this.deselect()

  }

  /**
   * 删除元素
   * @param {*} elem
   */
  removeElement(elem) {
    if (elem instanceof GraphElement) {            
      
      // 元素的入边或出边是母线时，删除元素时要删除母线上对应的端口
      const incomeEdges = elem.getIncomingEdges()
      const outgoingEdges = elem.getOutgoingEdges()

      // 删除端口
      for (const edge of incomeEdges) {
        if (edge.source.node instanceof BusElement) {
          edge.source.node.removePort(edge.source.port)
        }
      }
      for (const edge of outgoingEdges) {
         if (edge.target.node instanceof BusElement) {
          edge.target.node.removePort(edge.target.port)
        }
      }

      // 删除元素
      this.graph.removeVertex(elem)
      elem.g.remove()
      elem.executeRemovedHook()
      let trIds = ['#el-tr', '#bus-tr', '#base-el-tr']
      trIds.map(trId => {
        this.layer.findOne(trId)?.nodes([])
      })
      this.displayElement = this.displayElement.filter(ge => ge !== elem)          
    }
  }

  getPortById(uuid) {
    let ports = this.stage.find('.port')
    for (const port of ports) {
      if (port.attrs.uuid == uuid) {
        return port
      }
    }
  }


  /**
   * 获取元素
   * @param {*} key ge对象的key
   * @param {*} compareValue 待比较的值
   * @param {*} type 元素类型
   * @returns
   */
  getGE(key, compareValue, type) {
    let ge = this.displayElement.find(elem => {
      if (type) {
        return (compareValue == elem[key]) && (elem.type === type)
      }
      return compareValue == elem[key]
    })
    return ge
  }

  getNodeById(uuid) {
    return this.graph.getNodeById(uuid)
  }

  setZIndex(uuid, zIndex) {
    let node = this.getNodeById(uuid)
    if (node) {
      node.g.setZIndex(zIndex)
    }
  }

  clear() {
    this.displayElement.forEach(elem => {
      this.removeElement(elem)
    })
    this.deselect()
  }

}
